import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "@mui/material/IconButton";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

export default function DenseTable(props) {
  const { credential } = props;

  const [copied, setCopied] = React.useState(false);

  const [copyanchorEl, setCopyanchorEl] = React.useState(null);

  const handlecopyClick = (event) => {
    setCopyanchorEl(event.currentTarget);
  };

  const handlecopyClose = () => {
    setCopyanchorEl(null);
  };

  const copyopen = Boolean(copyanchorEl);
  const copyid = copyopen ? "simple-popover" : undefined;

  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        <TableHead style={{ backgroundColor: "#06396c" }}>
          <TableRow>
            <TableCell style={{ color: "#ffffff" }} align="center">
              name
            </TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">
              username
            </TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">
              password
            </TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">
              url format
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {credential.map((row) => (
            <TableRow key={row.name}>
              <TableCell align="center" component="th" scope="row">
                {row.app}
              </TableCell>
              {row.username === "null" ? (
                <TableCell align="center">NA</TableCell>
              ) : (
                <TableCell align="center">
                  {row.username}
                  <CopyToClipboard
                    text={row.username}
                    onCopy={() => setCopied(true)}
                  >
                    <IconButton
                      aria-label="Filter"
                      color="primary"
                      onClick={handlecopyClick}
                    >
                      <FileCopyOutlinedIcon />
                    </IconButton>
                  </CopyToClipboard>
                  <Popover
                    id={copyid}
                    open={copyopen}
                    anchorEl={copyanchorEl}
                    onClose={handlecopyClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <Typography style={{ color: "forestgreen" }}>
                      Copied!.
                    </Typography>
                  </Popover>
                </TableCell>
              )}
              {row.password === "null" ? (
                <TableCell align="center">NA</TableCell>
              ) : (
                <TableCell align="center">
                  {row.password}
                  <CopyToClipboard
                    text={row.password}
                    onCopy={() => setCopied(true)}
                  >
                    <IconButton
                      aria-label="Filter"
                      color="primary"
                      onClick={handlecopyClick}
                    >
                      <FileCopyOutlinedIcon />
                    </IconButton>
                  </CopyToClipboard>
                  <Popover
                    id={copyid}
                    open={copyopen}
                    anchorEl={copyanchorEl}
                    onClose={handlecopyClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <Typography style={{ color: "forestgreen" }}>
                      Copied!.
                    </Typography>
                  </Popover>
                </TableCell>
              )}
              <TableCell align="center">{`http://<${row.app} public-ip-address>:${row.port}`}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
